<template>
	<div class="inner-page form-audit-logs">

		<AppHead :title="`Form Audit Logs for case #${caseName}`" />

		<PageHeader 
			:title="`Audit Logs for: '${formData.name}'${formData.week ? ` - Week ${formData.week}` : ''}`"
			:desc="`Form Audit Logs for case: #${caseName}`"
			:hasButton="false"
			:showHelper="false"
			>
			<a :href="`/cases/${caseHash}/form-audit-logs/${formData.id}/export-csv`">
				<Button
					label="Export CSV"
					size="regular"
					color="blue"
					icon="download"
					/>
			</a>
		</PageHeader>

		<div
			v-if="formAuditLogs && formAuditLogs.length > 0" 
			class="log-viewer"
			>

			<div 
				v-for="log in formAuditLogs"
				class="log-entry"
				>

				<div class="log-date">
					{{ niceDate(log.created_at) }}
				</div>

				<div class="log-user">
					{{ log.user.name }} <span>({{ log.user.email }})</span>
				</div>

				<div class="log-action">
					{{ theAction(log) }}
				</div>

				<div class="log-ending">
					the '{{ formData.name }}{{ formData.week ? ` - Week ${formData.week}` : '' }}' form
				</div>

			</div>

		</div>

		<Placeholder v-else message="No audit logs found." />

	</div>
</template>

<script>

import moment from 'moment'

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import Placeholder from "@/Components/Placeholder"

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		Placeholder
	},
	layout: AppLayout,
	props: {
		formAuditLogs: {
			type: [Array, Object, Boolean],
			default: false
		},
		case: {
			type: Object,
			required: true
		},
		formData: {
			type: Object,
			required: true
		}
	},
	data: () => {
		return {
			
		}
	},
	mounted() {
		console.log('props', {
			formAuditLogs: this.formAuditLogs,
			case: this.case,
			formData: this.formData
		})
	},
	methods: {
		theAction(log) {

			switch (log.action) {
				case 'viewed':
					return 'viewed';
				case 'updated':
					return 'updated';
				case 'completed':
					return 'completed';
				case 'downloaded-pdf':
					return 'downloaded a PDF of';
				case 'downloaded-json':
					return 'downloaded a JSON file of';
				case 'downloaded-file':
					return 'downloaded the uploaded file from';
				default:
					return log.action;
			}
			
		},
		niceDate(date) {
			return moment(date).format('DD/MM/YYYY HH:mm')
		}
	},
	computed: {
		caseHash() {
			return this.case.hashid
		},
		caseName() {
			return this.case && this.case.enquiry_number ? this.case.enquiry_number : this.case.hashid
		}
	}
}

</script>

<style lang="sass">

.form-audit-logs
	.log-viewer
		border-radius: 6px
		background-color: #fff
		padding: 30px
		min-height: 200px
		display: flex
		flex-direction: column

		.log-entry
			padding: 15px 0
			border-bottom: 1px solid #f0f0f0
			display: flex
			flex-wrap: wrap
			gap: 5px
			font-size: 14px
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			align-items: center

			.log-date
				font-weight: 700
				color: #777
				margin-right: 30px
				border-radius: 2px
				background-color: #f8f8f8
				padding: 3px 7px

			.log-user
				span
					font-style: italic
					font-size: 12px
					opacity: 0.7

			.log-action
				font-weight: 700

</style>